(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // sections/main-product.liquid: gallery thumb swap, variant selection
  // (price/availability/add-button/URL), qty stepper, and the
  // recommendations fetch. Scoped to this section only (no cart AJAX --
  // that's a separate task; the add-to-cart button stays a plain submit).
  (function () {
    'use strict';

    var mainImage = document.getElementById('PdpMainImage');
    var thumbs = document.querySelectorAll('.thumbs .thumb-btn');

    function activateThumbBySrc(src) {
      if (!src) return;
      for (var i = 0; i < thumbs.length; i++) {
        var isMatch = thumbs[i].getAttribute('data-media-src') === src;
        thumbs[i].classList.toggle('active', isMatch);
      }
    }

    function setMainImage(src, alt) {
      if (!mainImage || !src) return;
      mainImage.src = src;
      if (alt) mainImage.alt = alt;
    }

    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function () {
        var src = this.getAttribute('data-media-src');
        var alt = this.getAttribute('data-media-alt');
        setMainImage(src, alt);
        activateThumbBySrc(src);
      });
    }

    // --- Quantity stepper (min 1, matches the mock's readonly qty input) ---
    // Scoped to #ProductForm so these selectors can never collide with an
    // unrelated `.qty-minus`/`.qty-plus`/`#Quantity` elsewhere on the page
    // (e.g. cart-drawer.liquid's own qty controls).
    var productForm = document.getElementById('ProductForm');
    var qtyInput = productForm ? productForm.querySelector('#Quantity') : null;
    var qtyMinus = productForm ? productForm.querySelector('.qty-minus') : null;
    var qtyPlus = productForm ? productForm.querySelector('.qty-plus') : null;

    function changeQty(delta) {
      if (!qtyInput) return;
      var current = parseInt(qtyInput.value, 10);
      if (isNaN(current)) current = 1;
      qtyInput.value = Math.max(1, current + delta);
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () { changeQty(-1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { changeQty(1); });

    // --- Specs accordion (snippets/product-specs.liquid's `.acc-head`
    // buttons; toggles independently per item, matching the mock's
    // `function acc(b){b.parentElement.classList.toggle('open')}`) ---
    var accordionHeads = document.querySelectorAll('.specs .acc-head');
    for (var a = 0; a < accordionHeads.length; a++) {
      accordionHeads[a].addEventListener('click', function () {
        this.parentElement.classList.toggle('open');
      });
    }

    // --- Variant selection ---
    var variantsJsonEl = document.querySelector('[data-product-variants-json]');
    var variants = [];
    if (variantsJsonEl) {
      try {
        variants = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var selects = document.querySelectorAll('.variant-select');
    var idInput = document.querySelector('[data-variant-id-input]');
    var addButton = document.querySelector('.add-to-cart');
    var addButtonText = document.querySelector('[data-add-to-cart-text]');
    var availabilityPill = document.querySelector('[data-availability-pill]');
    var priceEl = document.querySelector('.pdp .pricebox .price');

    var stringsEl = document.querySelector('[data-product-strings-json]');
    var strings = { addToCart: 'Aggiungi al carrello', unavailable: 'Non disponibile', soldOut: 'Esaurito', available: 'Disponibile' };
    if (stringsEl) {
      try {
        strings = JSON.parse(stringsEl.textContent);
      } catch (e) {
        // keep defaults above
      }
    }
    var ADD_TO_CART_LABEL = strings.addToCart;
    var UNAVAILABLE_LABEL = strings.unavailable;
    var SOLD_OUT_LABEL = strings.soldOut;
    var AVAILABLE_LABEL = strings.available;

    function sortedSelects() {
      return Array.prototype.slice.call(selects).sort(function (a, b) {
        return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
      });
    }

    function currentSelectedOptions() {
      return sortedSelects().map(function (select) { return select.value; });
    }

    function findMatchingVariant(selectedOptions) {
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var matches = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (variant.options[j] !== selectedOptions[j]) {
            matches = false;
            break;
          }
        }
        if (matches) return variant;
      }
      return null;
    }

    function renderPrice(variant) {
      if (!priceEl) return;
      var html = variant.price;
      if (variant.compareAtPrice) {
        html += ' <s class="compare-at">' + variant.compareAtPrice + '</s>';
      }
      html += ' <small>IVA incl.</small>';
      priceEl.innerHTML = html;
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (idInput) idInput.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.removeAttribute('data-add-id');
        }
        if (addButtonText) addButtonText.textContent = UNAVAILABLE_LABEL;
        if (availabilityPill) {
          availabilityPill.classList.remove('pill-teal');
          availabilityPill.classList.add('pill-muted');
          availabilityPill.textContent = UNAVAILABLE_LABEL;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.setAttribute('data-add-id', variant.id);
      }
      if (addButtonText) addButtonText.textContent = variant.available ? ADD_TO_CART_LABEL : UNAVAILABLE_LABEL;
      if (availabilityPill) {
        availabilityPill.classList.toggle('pill-teal', variant.available);
        availabilityPill.classList.toggle('pill-muted', !variant.available);
        availabilityPill.textContent = variant.available ? AVAILABLE_LABEL : SOLD_OUT_LABEL;
      }

      renderPrice(variant);

      if (variant.featuredMediaSrc) {
        setMainImage(variant.featuredMediaSrc, null);
        activateThumbBySrc(variant.featuredMediaSrc);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    if (selects.length > 0) {
      for (var s = 0; s < selects.length; s++) {
        selects[s].addEventListener('change', function () {
          var variant = findMatchingVariant(currentSelectedOptions());
          updateForVariant(variant);
        });
      }
    }

    // --- Related products (native recommendations endpoint) ---
    var recommendationsRoot = document.getElementById('ProductRecommendations');
    var recommendationsSection = document.getElementById('ProductRecommendationsSection');
    if (recommendationsRoot && recommendationsSection && recommendationsSection.dataset.recommendationsUrl) {
      fetch(recommendationsSection.dataset.recommendationsUrl)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var freshFragment = doc.getElementById('ProductRecommendations');
          if (freshFragment && freshFragment.innerHTML.trim() !== '') {
            recommendationsRoot.innerHTML = freshFragment.innerHTML;
            recommendationsSection.style.display = '';
          }
          // Empty response (no related products): leave the section hidden.
        })
        .catch(function () {
          // Network/parse failure: leave the (hidden) static render in
          // place rather than showing a broken state.
        });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
